import { render } from "./IdCheckReport.vue?vue&type=template&id=32ae6600&scoped=true"
import script from "./IdCheckReport.vue?vue&type=script&lang=js"
export * from "./IdCheckReport.vue?vue&type=script&lang=js"

import "./IdCheckReport.vue?vue&type=style&index=0&id=32ae6600&scoped=true&lang=css"

import exportComponent from "C:\\Users\\JOnuigbo\\mgs2\\RabbitsfootOperatorApps\\reportpanel\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32ae6600"]])

export default __exports__